<template>
<div>
  <div class="row" v-if="nothingToShow !=''">
  <div class="col text-center">
  <h3>{{nothingToShow}}</h3>
  </div>
  </div>
<div class="container fluid" v-else-if="isLoaded && user.authenticated">
  <div class="row">
    <div class="col-md-12">
      <p>
        <strong>Broker Name: </strong>{{brokerinfo.contractName}}<br>
        <strong>Address:</strong><br>{{brokerinfo.address}}<br>{{brokerinfo.cityStateZip}}<br>
        <br>
        <br>
        <strong>Contact Name:</strong>  {{brokerinfo.name}}<br>
        <strong>Phone Number:</strong>  {{brokerinfo.phoneNumber}}
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <p>Please fill out the form below to contact your broker.</p>
    </div>
  </div>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="row">
      <div class="col-md-6">
        <label class="label">Name</label>
        <p class="control has-icon has-icon-right">
          <b-input name="name" v-model="brokercontact.Name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('name') }" type="text"/>
          <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
      </div>
      <div class="col-md-6">
        <label class="label">Email</label>
        <p class="control has-icon has-icon-right">
          <b-input name="email" v-model="brokercontact.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" type="text"/>
          <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="label">Subject</label>
        <p class="control has-icon has-icon-right">
          <b-input name="subject" v-model="brokercontact.Subject" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('subject') }" type="text"/>
          <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
          <span v-show="errors.has('subject')" class="help is-danger">{{ errors.first('subject') }}</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label class="label">Message</label>
        <p class="control has-icon has-icon-right">
          <b-textarea name="message" v-model="brokercontact.Message" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('message') }" rows="5" type="textarea" />
          <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
          <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="control">
          <button class="btn btn-primary" type="submit">Submit</button>
        </p>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col text-center">
      <h4>{{contactBrokerSent}}</h4>
    </div>
  </div>
</div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>
</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalBroker',
  components: {
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      brokerinfo: null,
      brokercontact: {},
      contactBrokerSent: '',
      timer: '',
      user: auth.user,
      nothingToShow: 'There is no information to display at this time',
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then(() => {
        // Data is valid, so we can submit the form.
        let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/brokers/contactbroker'
        axios.post(uri, this.brokercontact, {headers: auth.getAuthHeader()}).then((response) => {
          this.contactBrokerSent = "We've received your request and it has been processed successfully"
          this.brokercontact = {}
          this.timer = setTimeout(() => { this.clearData() }, 1)
          this.timer = setTimeout(() => { this.contactBrokerSent = '' }, 10000)
        })
      }).catch(() => {
        this.contactBrokerSent = 'Sorry but something went wrong when processing your request, please try again'
      })
    },
    clearData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    },
    resetVendorForm () {
      this.brokercontact = {}
      this.$validator.validateAll().then((result) => {
        this.$validator.pause()
        this.$nextTick(() => {
          this.$validator.errors.clear()
          this.$validator.fields.items.forEach(field => field.reset())
          this.$validator.fields.items.forEach(field => this.errors.remove(field))
          this.$validator.resume()
        })
      })
    }
  },
  mounted: function () {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.resetVendorForm()
    })
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/brokers', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.brokerinfo = response.data
        this.nothingToShow = ''
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('brokerinfo') &&
      this.brokerinfo != null) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modalBroker.vue